import { message } from 'antd';
import { formatMessage } from 'umi';

import appInsightsService from '@/utils/appInsights';
import defaultSettings from '../config/defaultSettings';

const { pwa } = defaultSettings; // if pwa is true

appInsightsService.initialize();

if (pwa) {
  // Notify user if offline now
  window.addEventListener('sw.offline', () => {
    message.warning(formatMessage({ id: 'app.pwa.offline' }));
  }); // Pop up a prompt on the page asking the user if they want to use the latest version

  window.addEventListener('sw.updated', (event) => {
    const worker = event.detail && event.detail.waiting;
    if (!worker) return;

    const channel = new MessageChannel();
    channel.port1.onmessage = () => window.location.reload(true);
    worker.postMessage({ type: 'skip-waiting' }, [channel.port2]);
  });
} else if ('serviceWorker' in navigator) {
  // unregister service worker
  const { serviceWorker } = navigator;

  if (serviceWorker.getRegistrations) {
    serviceWorker.getRegistrations().then((sws) => {
      sws.forEach((sw) => {
        sw.unregister();
      });
    });
  }

  serviceWorker.getRegistration().then((sw) => {
    if (sw) sw.unregister();
  }); // remove all caches

  if (window.caches && window.caches.keys) {
    caches.keys().then((keys) => {
      keys.forEach((key) => {
        caches.delete(key);
      });
    });
  }
}
